// JOBE-0163.2 — GoalsFraming: Goals & Initiatives framing for W4 DepartmentPage.
// Renders a vertical stack of goal cards with initiative sub-rows and status pills.

import { Card }       from '../components/Card/Card.jsx';
import { StatusPill } from '../components/StatusPill/StatusPill.jsx';
import './GoalsFraming.css';

// Map goal/initiative status strings to StatusPill tone + label.
// Per JOBE-0163.2 spec status pill mapping table.
const STATUS_PILL = {
  ok:          { tone: 'ok',   label: 'On track' },
  watch:       { tone: 'warn', label: 'Watch' },
  'at-risk':   { tone: 'bad',  label: 'At risk' },
  done:        { tone: 'ok',   label: 'Done' },
  todo:        { tone: 'warn', label: 'Pending' },
  'in-progress': { tone: 'ok', label: 'In progress' },
};

function goalPill(status) {
  return STATUS_PILL[status] ?? { tone: 'pencil', label: status };
}

// Leading bullet glyph per initiative status.
function initBullet(status) {
  if (status === 'done')        return '✓';
  if (status === 'in-progress') return '●';
  return '○';
}

export default function GoalsFraming({ dept }) {
  const goals = dept?.goals ?? [];

  if (goals.length === 0) {
    return <p className="goals-empty">No goals defined for this department.</p>;
  }

  return (
    <div className="goals-framing" data-testid="framing-goals">
      {goals.map((goal, i) => {
        const { tone, label } = goalPill(goal.status);
        return (
          <Card key={i} className="goal-card">
            <div className="goal-head">
              <StatusPill tone={tone} label={label} />
              <span className="goal-title">{goal.title}</span>
              <span className="goal-meta">
                <span className="goal-owner">{goal.owner}</span>
                <span className="goal-due">Due: {goal.dueDate}</span>
              </span>
            </div>
            {goal.initiatives.length > 0 && (
              <>
                <hr className="goal-divider" />
                <ul className="initiative-list">
                  {goal.initiatives.map((init, j) => {
                    const { tone: it, label: il } = goalPill(init.status);
                    return (
                      <li key={j} className="initiative-row">
                        <span className="init-bullet" aria-hidden="true">
                          {initBullet(init.status)}
                        </span>
                        <span className="init-title">{init.title}</span>
                        <StatusPill tone={it} label={il} className="init-pill" />
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </Card>
        );
      })}
    </div>
  );
}
